module.exports = __webpack_public_path__ + "img/bonus.3d68ff73.svg";